import { User } from 'lucide-react';
import { useAppContext } from '../context/AppContext';

export default function ClientForm() {
  const { client, setClient, formatPhoneNumber, readOnlyState, userRole, salesPoints } = useAppContext();
  const canEditStore = userRole === 'admin';

  return (
    <div className="bg-white p-6 rounded-xl border border-stone-200/80 shadow-card space-y-5 h-full flex flex-col">
      <div className="flex items-center space-x-2 text-stone-800 font-semibold border-b border-stone-100 pb-3">
        <User className="w-4 h-4 text-brand-600" />
        <span className="text-xs uppercase tracking-wider font-semibold text-stone-700">Müşteri ve Tasarımcı Detayları</span>
      </div>

      <div className="space-y-3.5">
        <div>
          <label className="text-[11px] font-medium text-stone-500">Müşteri Ad Soyad</label>
          <input 
            type="text" 
            placeholder="Müşteri adını giriniz..."
            disabled={readOnlyState.isReadOnly}
            value={client.clientName} 
            onChange={e => setClient({ ...client, clientName: e.target.value })}
            className="w-full mt-1 px-3 py-2 text-xs rounded-lg border border-stone-200/90 focus:outline-none focus:ring-1 focus:ring-brand-500/30 focus:border-brand-500 bg-white disabled:bg-stone-50 disabled:cursor-not-allowed placeholder:text-stone-400 placeholder:font-normal text-stone-800 transition-all"
          />
        </div>
        <div>
          <label className="text-[11px] font-medium text-stone-500">Telefon</label>
          <input 
            type="text" 
            placeholder="0XXX XXX XX XX"
            disabled={readOnlyState.isReadOnly}
            value={client.phone} 
            onChange={e => setClient({ ...client, phone: formatPhoneNumber(e.target.value) })}
            className="w-full mt-1 px-3 py-2 text-xs rounded-lg border border-stone-200/90 focus:outline-none focus:ring-1 focus:ring-brand-500/30 focus:border-brand-500 bg-white disabled:bg-stone-50 disabled:cursor-not-allowed placeholder:text-stone-400 placeholder:font-normal text-stone-800 transition-all"
          />
        </div>
        <div>
          <label className="text-[11px] font-medium text-stone-500">Teslimat Adresi</label>
          <textarea 
            rows={2}
            placeholder="Teslimat adresini yazınız..."
            disabled={readOnlyState.isReadOnly}
            value={client.address} 
            onChange={e => setClient({ ...client, address: e.target.value })}
            className="w-full mt-1 px-3 py-2 text-xs rounded-lg border border-stone-200/90 focus:outline-none focus:ring-1 focus:ring-brand-500/30 focus:border-brand-500 bg-white disabled:bg-stone-50 disabled:cursor-not-allowed resize-none placeholder:text-stone-400 placeholder:font-normal text-stone-800 transition-all"
          />
        </div>
        <div>
          <label className="text-[11px] font-medium text-stone-500">Satış Noktası</label>
          {canEditStore ? (
            <select
              disabled={readOnlyState.isReadOnly}
              value={client.storeName || ''}
              onChange={e => setClient({ ...client, storeName: e.target.value })}
              className="w-full mt-1 px-3 py-2 text-xs rounded-lg border border-stone-200/90 focus:outline-none focus:ring-1 focus:ring-brand-500/30 focus:border-brand-500 bg-white disabled:bg-stone-50 disabled:cursor-not-allowed text-stone-700 font-normal transition-all"
            >
              <option value="">Satış Noktası Seçiniz...</option>
              {salesPoints.map(store => (
                <option key={store.id || store.name} value={store.name}>
                  {store.name}
                </option>
              ))}
            </select>
          ) : (
            <div className="w-full mt-1 px-3 py-2 text-xs rounded-lg border border-stone-200/80 bg-stone-50 text-stone-600">
              {client.storeName || 'Kullanıcınıza atanmış bir satış noktası bulunmuyor'}
            </div>
          )}
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-[11px] font-medium text-stone-500">Tasarımcı / Mimar</label>
            <input 
              type="text" 
              placeholder="Mimarın adı..."
              disabled={readOnlyState.isReadOnly}
              value={client.designer} 
              onChange={e => setClient({ ...client, designer: e.target.value })}
              className="w-full mt-1 px-3 py-2 text-xs rounded-lg border border-stone-200/90 focus:outline-none focus:ring-1 focus:ring-brand-500/30 focus:border-brand-500 bg-white disabled:bg-stone-50 disabled:cursor-not-allowed placeholder:text-stone-400 placeholder:font-normal text-stone-800 transition-all"
            />
          </div>
          <div>
            <label className="text-[11px] font-medium text-stone-500">CRM No</label>
            <input 
              type="text" 
              placeholder="CRM No..."
              disabled={readOnlyState.isReadOnly}
              value={client.crmNo || ''} 
              onChange={e => setClient({ ...client, crmNo: e.target.value })}
              className="w-full mt-1 px-3 py-2 text-xs rounded-lg border border-stone-200/90 focus:outline-none focus:ring-1 focus:ring-brand-500/30 focus:border-brand-500 bg-white disabled:bg-stone-50 disabled:cursor-not-allowed placeholder:text-stone-400 placeholder:font-normal text-stone-800 transition-all"
            />
          </div>
          <div>
            <label className="text-[11px] font-medium text-stone-500">Teklif Tarihi</label>
            <input 
              type="date" 
              disabled={readOnlyState.isReadOnly}
              value={client.date} 
              onChange={e => setClient({ ...client, date: e.target.value })}
              className="w-full mt-1 px-3 py-2 text-xs rounded-lg border border-stone-200/90 focus:outline-none focus:ring-1 focus:ring-brand-500/30 focus:border-brand-500 bg-white disabled:bg-stone-50 disabled:cursor-not-allowed text-stone-800 transition-all"
            />
          </div>
          <div>
            <label className="text-[11px] font-medium text-stone-500">Geçerlilik Tarihi</label>
            <input 
              type="date" 
              disabled={readOnlyState.isReadOnly}
              value={client.validityDate} 
              onChange={e => setClient({ ...client, validityDate: e.target.value })}
              className="w-full mt-1 px-3 py-2 text-xs rounded-lg border border-stone-200/90 focus:outline-none focus:ring-1 focus:ring-brand-500/30 focus:border-brand-500 bg-white disabled:bg-stone-50 disabled:cursor-not-allowed text-stone-800 transition-all"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
